export default __webpack_public_path__ + "static/media/branding-logo.6de3fde0.svg";